// extracted by mini-css-extract-plugin
module.exports = {"head":"_1WTRM6nm93mF","description":"RrVayP5c1Fh1"};